import { ActionTypes } from './constants';

const defaultState = () => ({
  contentfulLoading: false,
  entry: {},
});

export function contentful(state = defaultState(), action) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.CONTENTFUL_ENTRY_STARTED:
      return {
        ...state,
        contentfulLoading: true,
      };

    case ActionTypes.CONTENTFUL_ENTRY_COMPLETED:
      return {
        ...state,
        contentfulLoading: false,
        [payload.identifier]: payload.entry,
      };

    case ActionTypes.CONTENTFUL_ENTRY_FAILED:
      return {
        ...state,
        contentfulLoading: false,
        [payload.identifier]: {
          error: payload.error,
        },
      };

    default:
      return state;
  }
}
